import {Box, Skeleton} from '@mui/material';
import React from 'react';

export const DrawerContentWorkSpaceItemSkeleton = () => {
    return (
        <Box pl={1} pr={1} pb={1}>
            <Skeleton variant="rectangular" width={'100%'} height={'50px'} style={{borderRadius: '10px'}} />
        </Box>
    );
};

export default DrawerContentWorkSpaceItemSkeleton;
